// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 15:21:14
import { ListEquipmentType_abstract } from './../../abstract/SagaSchema/ListObjects/ListEquipmentType_abstract';
export class ListEquipmentType extends ListEquipmentType_abstract {}
